//#region Libraries
import styled from "styled-components";
//#endregion
import { Row } from "components/styles";

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #283044cc;
    z-index: 900;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 14px;
    transition: opacity 0.35s, visibility 0.35s;
    visibility: visible;
    opacity: 1;
    &.hidden {
        visibility: hidden;
        opacity: 0;
    }
`;
export const Popup = styled.section`
    background-color: var(--light-1);
    display: flex;
    position: fixed;
    border-radius: 4px;
    top: 0;
    left: 0;
    width: max-content;
    padding: 15px;
    z-index: 902;
    visibility: visible;
    opacity: 1;
    transition: 0.4s;
    &::after {
        display: block;
        content: "";
        position: absolute;
        top: 25px;
        left: 97%;
        border: 8px solid var(--light-1);
        transform: rotate(45deg);
        border-left-color: transparent;
        border-bottom-color: transparent;
    }
    &.right::after {
        left: unset;
        right: 97%;
        z-index: 100;
        transform: rotate(225deg);
    }
    &.top {
        &::after {
            top: 50px;
            bottom: unset;
        }
    }
    &.middle {
        &::after {
            top: unset;
            bottom: 46.5%;
        }
    }
    &.bottom {
        &::after {
            top: unset;
            bottom: 50px;
        }
    }
    &.hidden {
        visibility: hidden;
        opacity: 0;
    }
`;

export const Title = styled.h4`
    margin: 7px 0;
    font-size: 16px;
    font-weight: 900;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90%;
`;
export const DateTimeGroup = styled(Row).attrs({
    wrap: "nowrap"
})`
    &.black {
        svg {
            fill: var(--dark-4);
        }
        span {
            color: var(--dark-4);
        }
    }
    &.gray {
        svg {
            fill: var(--dark-3);
        }
        span {
            color: var(--light-gray-5);
        }
    }
`;
export const TextData = styled.span`
    font-size: 14px;
    font-weight: ${({ weight = "400" }) => weight};
    line-height: 20px;
    display: block;
    width: 100%;
    white-space: nowrap;
`;

export const FeatureData = styled.article`
    background-color: var(--light-blue-2);
    padding: 15px 20px;
    border-radius: 8px;
    align-self: center;
    width: 88%;
    & p {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
        &.ellipsis {
            white-space: nowrap;
        }
    }
`;